export default {
  // getItem: state => (projectId) => state.projects.find((project) => project.id == projectId),
}
